@if (editing(); as editingNode) {
  @if (editingComponent(); as component) {
    <ng-container *ngComponentOutlet="component; inputs: {
      item: editingConfig(),
      itemFilter: editingItemFilter(),
      operator: editingNode.operator,
      dataService: editingDataService(),
      queryFilter: editingQueryFilter(),
      }">
    </ng-container>
  }
}
@else {
  <div class="flex flex-col gap-4 flex-1 overflow-y-auto px-6 pb-4">
    @if (sourceTabs().length > 1) {
      <soft-ds-tabs [tabs]="sourceTabs()"
                    [variant]="'segmented'"
                    [size]="'sm'"
                    [layout]="'fill'"
                    [value]="sourceIndex()"
                    (valueChange)="$event !== null && sourceIndex.set($event)"
                    data-testid="filter-custom-source-tabs">
      </soft-ds-tabs>
    }
    @if (currentTree(); as tree) {
      <soft-filter-node [node]="tree" [depth]="0"></soft-filter-node>
    }
  </div>
}
